<template>
  <a-card :bordered="false">
    <div>
      <a-button type="primary" @click="openModel">添加关联账号</a-button>
    </div>
    <custom-page-table
      style="margin-top: 16px;"
      ref="table"
      :columns="columns"
      base-key="proUrl"
      requestType="get"
      params-path="wisdom/query/provider/list"
    >
      <span slot="providerStatus" slot-scope="rowItem">
        {{ rowItem.record.providerStatus == 1 ? '启用' : '禁用' }}
      </span>
      <span slot="action" slot-scope="rowItem">
        <a style="margin-right: 20px;" @click="editEvent(rowItem.record)">编辑</a>
        <a v-if="rowItem.record.providerStatus == 0" @click="enableEvent(rowItem.record.providerId)">启用</a>
        <a
          v-else-if="rowItem.record.providerStatus == 1"
          @click="forbiddenEvent(rowItem.record.providerId)"
          style="color: red;"
        >禁用</a
        >
      </span>
    </custom-page-table>
    <a-modal title="添加关联账号" :width="666" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="providerForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="供应商名称" prop="providerName">
          <a-input
            v-model.trim="providerForm.providerName"
            style="width: 400px;"
            :maxLength="6"
            placeholder="仅用于区分标识数据来源，6个字内"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="接口域名(url)" prop="providerUrl">
          <a-input v-model.trim="providerForm.providerUrl" style="width: 400px;"></a-input>
        </a-form-model-item>
        <a-form-model-item label="合作方ID(partnerId)" prop="providerPartnerId">
          <a-input v-model.trim="providerForm.providerPartnerId" style="width: 400px;"></a-input>
        </a-form-model-item>
        <a-form-model-item label="合作方验证(Secret)" prop="providerPartnerSecret">
          <a-input v-model.trim="providerForm.providerPartnerSecret" style="width: 400px;"></a-input>
        </a-form-model-item>
        <a-form-model-item label="合作方景点ID(clientId)" prop="providerPartnerProId">
          <a-input v-model.trim="providerForm.providerPartnerProId" style="width: 400px;"></a-input>
        </a-form-model-item>
        <div style="text-align: center;">
          <a-button type="primary" @click="submitForm()" style="width: 180px;">提交</a-button>
        </div>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'AddAccount',
  data() {
    return {
      columns: [
        {
          title: '供应商名称',
          dataIndex: 'providerName'
        },
        {
          title: '接口域名',
          dataIndex: 'providerUrl'
        },
        {
          title: '合作方ID(partnerId)',
          dataIndex: 'providerPartnerId'
        },
        {
          title: '合作方验证(Secret)',
          dataIndex: 'providerPartnerSecret'
        },
        {
          title: '状态',
          dataIndex: 'providerStatus',
          scopedSlots: { customRender: 'providerStatus' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      labelCol: { span: 7 },
      wrapperCol: { span: 14 },
      visible: false,
      providerForm: {
        providerName: '',
        providerUrl: '',
        providerPartnerId: '',
        providerPartnerSecret: '',
        providerPartnerProId: '',
        providerId: ''
      },
      rules: {
        providerName: [{ required: true, message: '请输入供应商名称', trigger: 'change' }],
        providerUrl: [{ required: true, message: '请输入接口域名', trigger: 'change' }],
        providerPartnerId: [{ required: true, message: '请输入合作方ID', trigger: 'change' }],
        providerPartnerSecret: [{ required: true, message: '请输入合作方验证(Secret)', trigger: 'change' }],
        providerPartnerProId: [{ required: true, message: '请输入合作方景点ID', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'YzhConnection', title: '商品绑定' },
      { name: 'OrderConnection', title: '订单直连' },
      { name: 'AddAccount', title: '关联账号' }
    ])
  },
  methods: {
    //启用事件
    enableEvent(providerId) {
      this.updateProviderStatus(providerId, 1)
    },
    //编辑事件
    editEvent(item) {
      this.getLogUtils().logWithTag('editEvent== item', item)
      this.providerForm = {
        providerName: item.providerName,
        providerUrl: item.providerUrl,
        providerPartnerId: item.providerPartnerId,
        providerPartnerSecret: item.providerPartnerSecret,
        providerPartnerProId: item.providerPartnerProId,
        providerId: item.providerId
      }
      this.visible = true
    },
    //禁用事件
    forbiddenEvent(providerId) {
      this.updateProviderStatus(providerId, 0)
    },
    //状态更新
    updateProviderStatus(providerId, providerStatus) {
      let url = 'wisdom/switch/provider/list/' + providerId + '/' + providerStatus
      this.getHttpServices()
        .getProService()
        .get(url)
        .then(res => {
          this.$refs.table.refresh(true)
          this.$message.success('状态更新成功')
        })
        .catch(err => {
          this.getLogUtils().logWithTag('err', err)
        })
    },
    //提交事件
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.getHttpServices()
            .getProService()
            .post('wisdom/save/provider', this.providerForm)
            .then(res => {
              this.$message.success('数据更新成功')
              this.visible = false
              this.$refs.table.refresh(true)
            })
            .catch(err => {
              this.$message.error('数据更新失败')
            })
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    openModel() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
<style scoped></style>
